
import { useRoute } from 'vue-router'
import { COMPONENTS } from '@/router/index'
import { reactive } from 'vue'
// import Button from '@/components/button/Button.vue'

export default {
  components: {
    // Button
  },
  setup() {
    const route = useRoute()
    const componentsList = reactive(COMPONENTS)

    return {
      componentsList
    }
  }
}
